/** @jsxImportSource react */
import {useEffect,useId,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {ArrowUpRight,ChevronDown} from 'lucide-react';
import {useLanguage} from '../i18n/LanguageProvider';
import {CURRENT_SITE_ID,WEBSITES,websiteNetworkLabels} from '../lib/website-network';
import '../styles/website-network.css';

function WebsiteNetworkList(){
  const {locale}=useLanguage(),labels=websiteNetworkLabels(locale);
  return <ul className="website-network__list">{WEBSITES.map(site=>{
    const current=site.id===CURRENT_SITE_ID;
    const content=<><span className="website-network__logo" aria-hidden="true">{site.logo?<img src={site.logo} alt=""/>:site.name[0]}</span><span className="website-network__copy"><span className="website-network__name">{site.name}</span><span className="website-network__host">{site.host}</span>{current&&<span className="website-network__status"><i aria-hidden="true"/>{labels.current}</span>}</span>{!current&&<><ArrowUpRight size={17} aria-hidden="true"/><span className="website-network__sr-only">{labels.newTab}</span></> } </>;
    return <li key={site.id}>{current?<div className="website-network__card is-current" aria-current="true">{content}</div>:<a className="website-network__card" href={site.url} target="_blank" rel="noopener noreferrer" title={labels.newTab}>{content}</a>}</li>;
  })}</ul>;
}

export function WebsiteNetworkMenu(){
  const {locale}=useLanguage(),labels=websiteNetworkLabels(locale),{pathname}=useLocation();
  const [open,setOpen]=useState(false),host=useRef<HTMLDivElement>(null),button=useRef<HTMLButtonElement>(null),id=useId();
  useEffect(()=>setOpen(false),[pathname,locale]);
  useEffect(()=>{
    if(!open)return;
    const outside=(event:PointerEvent)=>{if(!host.current?.contains(event.target as Node))setOpen(false)};
    const escape=(event:KeyboardEvent)=>{if(event.key==='Escape'){setOpen(false);button.current?.focus()}};
    document.addEventListener('pointerdown',outside);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('keydown',escape)};
  },[open]);
  return <div translate="no" ref={host} className="website-network website-network--menu" onBlur={event=>{if(!event.currentTarget.contains(event.relatedTarget as Node))setOpen(false)}}>
    <button ref={button} type="button" className="website-network__trigger" aria-expanded={open} aria-controls={id} onClick={()=>setOpen(value=>!value)}>{labels.title}<ChevronDown size={14} aria-hidden="true"/></button>
    <div id={id} className={'website-network__panel'+(open?' is-open':'')} inert={!open} aria-hidden={!open}><WebsiteNetworkList/></div>
  </div>;
}

export function WebsiteNetworkFooter({mobile=false}:{mobile?:boolean}){
  const {locale}=useLanguage(),labels=websiteNetworkLabels(locale),id=useId();
  return <section translate="no" className={'website-network website-network--'+(mobile?'mobile':'footer')} aria-labelledby={id}><h2 id={id}>{labels.title}</h2><WebsiteNetworkList/></section>;
}
